module.exports = __webpack_public_path__ + "img/mars-bg.154e165e.jpg";